"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Phone_1 = __importDefault(require("@kyruus/react-ikons/Phone"));
const Fax_1 = __importDefault(require("@kyruus/react-ikons/Fax"));
const intl_1 = require("@kyruus/intl");
const availability_tiles_1 = require("@kyruus/availability-tiles");
const Location_styles_1 = require("./Location.styles");
const util_1 = require("../../common/util");
const Availability_1 = require("./Availability");
const LocationLink_1 = require("./LocationLink");
const types_1 = require("../../types");
const util_2 = require("../../common/util");
const RouteInfo_1 = require("../RouteInfo");
const getPhoneAndOrFaxColumn = (location, headers, intl, track) => {
    const trackPhoneFaxAnchorClick = () => track('user_action.provider_card.location_phone');
    const hasPhoneOrFax = headers.phone || headers.fax;
    const hasPhoneAndFax = headers.phone && headers.fax;
    const iconSize = '16px';
    if (hasPhoneOrFax) {
        const phoneNumber = headers.phone &&
            (0, util_1.getContactValue)(location, {
                primary: types_1.CONTACT_TYPE.PMC_PHONE,
                secondary: types_1.CONTACT_TYPE.PHONE
            });
        const faxNumber = headers.fax &&
            (0, util_1.getContactValue)(location, {
                primary: types_1.CONTACT_TYPE.PMC_FAX,
                secondary: types_1.CONTACT_TYPE.FAX
            });
        return (react_1.default.createElement(Location_styles_1.PhoneFaxNumberTd, null,
            react_1.default.createElement("div", null,
                phoneNumber && (react_1.default.createElement(react_1.default.Fragment, null,
                    hasPhoneAndFax && (react_1.default.createElement(Phone_1.default, { size: iconSize, "aria-hidden": true, title: `${intl.formatMessage(util_1.messages.phone)} - ${location.name}` })),
                    react_1.default.createElement(Location_styles_1.PhoneFaxAnchor, { href: `tel:${phoneNumber}`, "aria-label": intl.formatMessage(util_1.messages.ariaLocationPhoneNumberLink, {
                            phone: phoneNumber,
                            locationName: location.name
                        }), onClick: trackPhoneFaxAnchorClick }, phoneNumber))),
                faxNumber && (react_1.default.createElement(react_1.default.Fragment, null,
                    hasPhoneAndFax && (react_1.default.createElement(Fax_1.default, { size: iconSize, "aria-hidden": true, title: `${intl.formatMessage(util_1.messages.fax)} - ${location.name}` })),
                    react_1.default.createElement(Location_styles_1.PhoneFaxAnchor, { href: `tel:${faxNumber}`, "aria-label": intl.formatMessage(util_1.messages.ariaLocationFaxNumberLink, {
                            fax: faxNumber,
                            locationName: location.name
                        }), onClick: trackPhoneFaxAnchorClick }, faxNumber))))));
    }
    return null;
};
const Location = ({ config, location, headers, searchedLocation, track, apptInfo, availability, slotsStatus, onClickShowAvailability, availabilityTilesMessages, provider, bookOnlineUrl, shouldDisplayAvailability, isAvailabilityReadOnly = false, availabilityLinkTarget, onTimeSlotsClick, onViewMoreClick, onAvailabilityTilesLoaded, getLocationUrl, locationCallback, locationCTA, intl, shouldRenderSlotsAsButtons = false }) => {
    const distance = (location.distance && location.distance.toFixed(2)) || undefined;
    const maxAvailabilitiesToDisplay = isAvailabilityReadOnly
        ? util_2.READ_ONLY_MAX_AVAILABILITIES_TO_DISPLAY
        : util_2.MAX_AVAILABILITIES_TO_DISPLAY;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Location_styles_1.LocationRow, { "data-name": location.name, key: location.name },
            react_1.default.createElement(Location_styles_1.AddressTd, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(LocationLink_1.LocationLink, { location: location, getLocationUrl: getLocationUrl, locationCallback: locationCallback }, location.name),
                    (0, util_1.getLocationDisplayAddress)(location),
                    react_1.default.createElement(RouteInfo_1.RouteInfo, { config: config, location: location, searchedLocation: searchedLocation, track: track, distance: distance })),
                (location === null || location === void 0 ? void 0 : location.provider_accepting_new_patients_at_location) && (react_1.default.createElement(Location_styles_1.StyledProviderBadge, { "data-testid": `badge_chip_accepting_new_patient`, label: intl.formatMessage(util_1.messages.acceptingNewPatientMessage), size: "small" }))),
            getPhoneAndOrFaxColumn(location, headers, intl, track),
            locationCTA && (react_1.default.createElement(Location_styles_1.LocationCtaTd, null, locationCTA({
                location: location,
                provider: provider
            })))),
        shouldDisplayAvailability && location.slots && (react_1.default.createElement(Location_styles_1.AvailabilityRow, { shouldHideBelowScreenMedium: !availability },
            slotsStatus === util_2.SLOTS_LOADING_STATUS && (react_1.default.createElement(Location_styles_1.AvailabilityTd, { colSpan: 4, isAvailabilityReadOnly: isAvailabilityReadOnly },
                react_1.default.createElement(availability_tiles_1.LoadingAvailabilityTiles, { maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay }))),
            apptInfo && (react_1.default.createElement(Location_styles_1.AvailabilityTd
            // there can be up to 3 columns in the table (address, phone, action button)
            , { 
                // there can be up to 3 columns in the table (address, phone, action button)
                colSpan: 3, isAvailabilityReadOnly: isAvailabilityReadOnly },
                react_1.default.createElement(Availability_1.Availability, { apptInfo: apptInfo, availability: availability, slotsStatus: slotsStatus, isAvailabilityReadOnly: isAvailabilityReadOnly, onClickShowAvailability: onClickShowAvailability, availabilityTilesMessages: availabilityTilesMessages, providerId: provider.id, bookOnlineUrl: bookOnlineUrl, availabilityLinkTarget: availabilityLinkTarget, onTimeSlotsClick: onTimeSlotsClick, onViewMoreClick: onViewMoreClick, onAvailabilityTilesLoaded: onAvailabilityTilesLoaded, shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons, locationName: location.name })))))));
};
exports.default = (0, intl_1.injectIntl)(Location);
//# sourceMappingURL=Location.js.map